import { createContext, useEffect, useState } from "react";
import {jwtDecode} from "jwt-decode";


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const storedToken = localStorage.getItem("token");
  let initialUser = null;

  if (storedToken) {
    try {
      const decoded = jwtDecode(storedToken);
      initialUser = {
        token: storedToken,
        id: decoded.id || decoded.user_id,
        role: decoded.role
      };

    } catch (error) {
      console.error("Token inválido en localStorage:", error);
      localStorage.removeItem("token");
    }
  }

  const [user, setUser] = useState(initialUser);

  const isTokenExpired = (decodedToken) => {
    if (!decodedToken.exp) return true;
    return Date.now() >= decodedToken.exp * 1000;
  };

 useEffect(() => {
  if (!user && storedToken) {
    try {
      const userData = jwtDecode(storedToken);
      if (isTokenExpired(userData)) {
        console.warn("Token expirado");
        logout();
      } else {
        setUser({ token: storedToken, id: userData.id || userData.user_id, role: userData.role });
      }
    } catch (error) {
      console.error("Error al decodificar el token:", error);
      logout();
    }
  }
}, [user, storedToken]);


  const login = (newToken) => {
    localStorage.setItem("token", newToken);
    const decoded = jwtDecode(newToken);
    setUser({ token: newToken, id: decoded.id || decoded.user_id, role: decoded.role });
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
